.ugc-review-mw-all-images-modal-wrap {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-flow: row;
  .image-item {
    place-items: start;
    width: 100%;
  }
}
